import React from "react";
import { Modal, Box, Typography, Divider, Slide } from "@mui/material";
import { ReactComponent as BulueDiamond } from "assets/filter/filter header/blue_diamond.svg";


const DiamondQualityModal = ({ open, handleClose, data }) => {

    return (
        <Modal
            open={open}
            onClose={handleClose}
            aria-labelledby="diamond-quality-modal"
            aria-describedby="diamond-quality-breakdown"
            BackdropProps={{ style: { backgroundColor: "transparent" } }}
        >
            <Slide direction="left" in={open} mountOnEnter unmountOnExit timeout={500}>
                {/* Popup container */}
                <Box
                    sx={{
                        position: "absolute",
                        bottom: 30,
                        right: 30,
                        width: "430px",
                        height: "458px",
                        backgroundColor: "#FFFFFF",
                        borderRadius: "5px 5px 0 0",
                        boxShadow: 24,
                        p: "20px 30px",
                        outline: "none",
                        display: "flex",
                        flexDirection: "column",
                        opacity: 1,
                        boxSizing: "border-box",
                   
                    }}
                >
                    {/* Header */}
                    <Box
                        sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            mb: "20px",
                            height: "24px"
                            
                        }}
                    >
                        <Typography
                            sx={{
                                fontFamily: "Poppins",
                                fontWeight: 600,
                                fontSize: "20px",
                                color: "#333",
                                lineHeight: 1
                            }}
                        >
                            Diamond Quality
                        </Typography>

                        <BulueDiamond width={22} height={22} />

                    </Box>

                    <Divider
                        sx={{
                            backgroundColor: "#E0E0E0",
                            width: "100%",
                            mb: "20px"
                        }}
                    />




                    {/* List */}
                    <Box
                        sx={{
                            display: "flex",
                            flexDirection: "column",
                            gap: "25px",
                            overflowY: "auto"
                        }}
                    >
                        {(data || []).map((item, index) => (
                            <Box
                                key={index}
                                sx={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                    width: "100%"
                                }}
                            >
                                <Typography
                                    sx={{
                                        fontFamily: "Karla",
                                        fontSize: "18px",
                                        fontWeight: 400,
                                        color: "#333",
                                    }}
                                >
                                    {item.quality}
                                </Typography>

                                <Typography
                                    sx={{
                                        fontFamily: "Karla",
                                        fontSize: "18px",
                                        fontWeight: "bold",
                                        color: "#333",
                                    }}
                                >
                                    {item.count.toString().padStart(2, "0")}
                                </Typography>
                            </Box>
                        ))}
                    </Box>
                </Box>
            </Slide>
        </Modal>
    );
};

export default DiamondQualityModal;
